<input type="hidden" id="selNum" value="0">
<h2 id="title-select-seat" #top>Scelta posti</h2>
<section id="recap" class="fx-row" style="gap: 2%">
  @if (trainSeat.transportUnits && trainSeat.transportUnits[0]!=null) {
    <div class="fx-flex-50">
      @for (seats of trainSeat.transportUnits; track seats) {
        <div class="wagon-container text-center">
          @if (seats) {
            <h3>Vagone {{seats.seatsAvailability.wagonId}}</h3>
            <iframe id="wagon-{{seats.seatsAvailability.wagonId}}" [srcdoc]="seats.layout | safe_content"
              frameborder="0"
              on-load="markSeleableSeats(seats.seatsAvailability.wagonId)"
            (mouseover)="selWagon(seats.seatsAvailability.wagonId)"></iframe>
          }
        </div>
      }
    </div>
    <div class="fx-flex-50">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{trainInfo.type}}
          {{trainInfo.name}} </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (p of travellers | keyvalue; track p) {
            <div>
              <h3><strong>Passeggero {{+p.key + 1}}
                <span>{{p.value.type == 'ADULT' ? 'ADT' : 'CHD'}}</span></strong>
              </h3>
              <h4>{{selectedOffers[p.value.xmlId][trainInfo.id].offer.name}} - {{selectedOffers[p.value.xmlId][trainInfo.id].service.name}}</h4>
              <div>Costo Selezione posto:
                @if (trainSeat.travellers[p.value.xmlId].seat_is_free) {
                  <span class="free">Gratis</span>
                }
                @if (!trainSeat.travellers[p.value.xmlId].seat_is_free && trainSeat.travellers[p.value.xmlId].prices) {
                  <span>{{trainSeat.travellers[p.value.xmlId].prices.amount}} €</span>
                }
              </div>
              @if (trainSeat.travellers[p.value.xmlId].seat) {
                <div class="fx-row" style="gap: 8px">
                  <span matTooltip="Vagone" class="train-ticket-seat">
                    <mat-icon>train</mat-icon>
                    {{trainSeat.travellers[p.value.xmlId].seat.wagon}}
                  </span>
                  <span matTooltip="Posto" class="train-ticket-seat">
                    <mat-icon>event_seat</mat-icon>
                    {{trainSeat.travellers[p.value.xmlId].seat.seatNumToShow}}
                  </span>
                </div>
              }
              <!--<div>Posto:
              <span *ngIf="trainSeat.travellers[p.value.xmlId].seat">
                <strong>{{trainSeat.travellers[p.value.xmlId].seat.seatNumToShow}} - </strong>
              </span>
            </div>
            <div>
              Vagone:
              <span *ngIf="trainSeat.travellers[p.value.xmlId].seat">
                <strong>{{trainSeat.travellers[p.value.xmlId].seat.wagon}}</strong>
              </span>
            </div>-->
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
@if (!trainSeat.transportUnits || trainSeat.transportUnits[0]==null) {
  <div class="fx-flex-50">
    <div class="alert-message"> Selezione posti non possibile per questo treno</div>
  </div>
}
</section>
<section>

</section>


